let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jBsSN")).then(() => parcelRequire('3DVt4'));